import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-564745a2"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "teacher-card-container"
};
const _hoisted_2 = {
  class: "teacher-info-wrapper"
};
const _hoisted_3 = {
  class: "teacher-info"
};
const _hoisted_4 = {
  class: "teacher-name"
};
const _hoisted_5 = {
  class: "teacher-organ"
};
const _hoisted_6 = {
  class: "teacher-avatar"
};
const _hoisted_7 = ["src"];

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "split-line"
}, null, -1));

const _hoisted_9 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "teacher-card",
    onClick: _cache[0] || (_cache[0] = $event => $options.openDetail($props.teacherData.id))
  }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString($props.teacherData.teacher_name), 1), _createElementVNode("div", _hoisted_5, _toDisplayString($props.teacherData.organ_name), 1)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
    src: $props.teacherData.teacher_avatar_url || 'https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202508/dd41a1a027e2458ab0655ac9e8d0f004.png',
    alt: ""
  }, null, 8, _hoisted_7)])]), _hoisted_8, _createElementVNode("div", {
    class: "teacher-intro",
    innerHTML: _ctx.$utils.getContentText($props.teacherData.introduction)
  }, null, 8, _hoisted_9)])]);
}